// This file was generated by org.multipaz.processor.CodeBuilder, do not edit by hand
package org.multipaz.documenttype.knowntypes

import org.multipaz.cbor.DataItem
import org.multipaz.documenttype.knowntypes.PaymentTransaction.Payee
import org.multipaz.cbor.Cbor
import kotlinx.io.bytestring.ByteString
import org.multipaz.cbor.annotation.CborSerializableGenerated
import org.multipaz.cbor.CborMap
import org.multipaz.cbor.Tstr

fun Payee.toCbor(): ByteArray {
    return Cbor.encode(toDataItem())
}

@CborSerializableGenerated(schemaId = "w5RVK7qPPJGfUG547ZjHcbLlr-3SVxSlIHzPbjREbjU")
val Payee_cborSchemaId = ByteString(-61, -108, 85, 43, -70, -113, 60, -111, -97, 80, 110, 120, -19, -104, -57, 113, -78, -27, -81, -19, -46, 87, 20, -91, 32, 124, -49, 110, 52, 68, 110, 53)

fun Payee.Companion.fromCbor(data: ByteArray): Payee {
    return Payee.fromDataItem(Cbor.decode(data))
}

val Payee.Companion.cborSchemaId: ByteString
    get() = Payee_cborSchemaId

fun Payee.toDataItem(): DataItem {
    val builder = CborMap.builder()
    builder.put("name", Tstr(this.name))
    builder.put("id", Tstr(this.id))
    val logo = this.logo
    if (logo != null) {
        builder.put("logo", Tstr(logo))
    }
    val website = this.website
    if (website != null) {
        builder.put("website", Tstr(website))
    }
    return builder.end().build()
}

fun Payee.Companion.fromDataItem(dataItem: DataItem): Payee {
    val name = dataItem["name"].asTstr
    val id = dataItem["id"].asTstr
    val logo0 = if (dataItem.hasKey("logo")) {
        dataItem["logo"].asTstr
    } else {
        null
    }
    val website0 = if (dataItem.hasKey("website")) {
        dataItem["website"].asTstr
    } else {
        null
    }
    return Payee(
        name = name,
        id = id,
        logo = logo0,
        website = website0,
    )
}
